import { supabase } from '@/lib/supabase';

export type Announcement = {
  id: string;
  creator_id: string;
  creator_name: string | null;
  creator_avatar: string | null;
  creator_business_logo?: string | null;
  creator_use_logo?: boolean | null;
  text: string;
  image_url: string | null;
  created_at: string;
  expires_at: string;
  paid_notification: boolean;
};

export async function createAnnouncement(
  text: string,
  imageUrl: string | null = null,
  paidNotification = false,
): Promise<string> {
  const { data, error } = await supabase.rpc('create_announcement', {
    p_text: text,
    p_image_url: imageUrl ?? undefined,
    p_paid_notification: paidNotification,
  });
  if (error) throw new Error(error.message);
  return data as string;
}

export async function getCircleAnnouncements(): Promise<Announcement[]> {
  const { data, error } = await supabase.rpc('get_circle_announcements');
  if (error) throw new Error(error.message);
  return (data as Announcement[]) ?? [];
}

export type AnnouncementCooldownStatus = {
  free_available_at: string | null;
  paid_available_at: string | null;
};

/** null σε ένα από τα δύο πεδία σημαίνει "διαθέσιμο τώρα" — δεν υπάρχει cooldown. */
export async function getAnnouncementCooldownStatus(): Promise<AnnouncementCooldownStatus> {
  const { data, error } = await supabase.rpc('get_announcement_cooldown_status' as any);
  if (error) throw new Error(error.message);
  return data as AnnouncementCooldownStatus;
}
